function setItem(name, value, minutes) {
    let expires = '';
    if (minutes) {
        const date = new Date();
        date.setTime(date.getTime() + (minutes * 60 *1000));
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value}${expires};SameSite=Strict; path=/`;
}

// https://stackoverflow.com/a/15724300/1383262
function getItem(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) {
        return parts.pop().split(";").shift();
    };
    return null;
}

function deleteItem(name) {
    setItem(name,'', -1);
}

export default {
    setItem,
    getItem,
    deleteItem,
}
